import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';



const key = "b3979b326af181e2a6ff80ad08da717a";
const proxy = "https://cors-anywhere.herokuapp.com/";



class Recipe extends Component {
    state = { 
        activeRecipe: "",
        error: false
    }
    parent = React.createRef();
    componentDidMount = async () => {
        const id = this.props.match.params.id;
        try {

            const res = await fetch(`${proxy}https://www.food2fork.com/api/get?key=${key}&rId=${id}`);
            const data = await res.json();
            this.setState({activeRecipe: data.recipe});
        } catch (error) {
            this.setState({error: true})
        }
    }

    render() { 
        const recipe = this.state.activeRecipe;
        return (
            
            <div>
                <Header />
                <div className="wrapper container">
                    {
                        !this.state.activeRecipe && <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                    }
                    {
                        this.state.error && 
                        <div className="alert alert-danger" role="alert">
                            Oops, something went wrong...Try agin.
                        </div>
                    }
                    {
                        
                        (this.state.activeRecipe) && 
                            <React.Fragment>
                                <h2 className="my-5 text-danger text-center">{recipe.title}</h2>
                                <div className="card mb-5 shadow-sm">
                                    <img src={recipe.image_url} className="card-img-top" alt={recipe.title} />
                                    <div className="card-body">
                                        <p className="card-text">Author: {recipe.publisher}</p>
                                        <a href={recipe.source_url} target="_blank" rel="noopener noreferrer" className="btn btn-outline-danger">Recipe Source</a>
                                    </div>
                                </div>
                                <h3 className="my-3 text-danger text-center">Ingredients</h3>
                                <ul className="list-group list-group-flush mb-5 shadow-sm">
                                    {
                                        recipe.ingredients.map((ingredient, index) => {
                                            return(
                                                
                                                <li key={index} className="list-group-item">{ingredient}</li>
                                            );
                                        })
                                    }
                                </ul>
                            </React.Fragment>
                    }
                </div>
                <Footer />
            </div>
          
        );
    }
}
 
export default Recipe;